<template>
    <div class="section pt-2 pb-5">
        <div class="listed-detail mt-1">
            <h3 class="text-center mal-text custom-title">Verification Officers — Approval</h3>
        </div>

        <!-- Status tabs -->
        <div class="section" style="display:flex;gap:6px;">
            <button class="vo-tab" @click="setStatus('pending')"
                :style="status==='pending' ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;'">
                Pending
            </button>
            <button class="vo-tab" @click="setStatus('approved')"
                :style="status==='approved' ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;'">
                Approved
            </button>
            <button class="vo-tab" @click="setStatus('rejected')"
                :style="status==='rejected' ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;'">
                Rejected
            </button>
        </div>

        <div class="section text-center mt-2" v-if="loading">
            <div class="spinner-border text-primary"></div>
        </div>

        <div v-else-if="!list.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
            {{ status === 'pending' ? 'അപ്രൂവലിനായി കാത്തിരിക്കുന്നവർ ഇല്ല' : 'അപ്രൂവ് ചെയ്തവർ ഇല്ല' }}
        </div>

        <div v-else class="section">
            <div v-for="vo in list" :key="vo.id" class="card mb-2" style="border-radius:12px;">
                <div class="card-body" style="padding:14px 16px;">
                    <div class="d-flex justify-content-between align-items-start mb-1">
                        <div>
                            <div style="font-size:15px;font-weight:800;color:#1e293b;">{{ vo.name }}</div>
                            <div style="font-size:12px;color:#64748b;">{{ vo.mobile }}</div>
                            <div style="font-size:11px;color:#1a418c;font-weight:600;" v-if="vo.program_title">{{ vo.program_title }}</div>
                            <div style="font-size:11px;color:#94a3b8;">
                                {{ vo.district_name }}<span v-if="vo.zone_name"> · {{ vo.zone_name }}</span>
                            </div>
                            <div style="font-size:11px;color:#94a3b8;" v-if="vo.suggested_by_name">
                                ചേർത്തത്: {{ vo.suggested_by_name }}<span v-if="vo.created_at"> · {{ vo.created_at }}</span>
                            </div>
                        </div>
                        <span class="badge" :class="statusBadge(vo.approval_status)">
                            {{ statusLabel(vo.approval_status) }}
                        </span>
                    </div>

                    <!-- Suggestion Q&A the district admin provided (read-only) -->
                    <div class="mt-2" v-if="(vo.suggestion_questions || []).length">
                        <div class="vo-q-head mal-text">ചേർത്തപ്പോൾ നൽകിയ വിവരങ്ങൾ</div>
                        <div v-for="q in vo.suggestion_questions" :key="'sq_'+q.key" class="vo-qa-row">
                            <span class="vo-qa-label mal-text">{{ q.label }}</span>
                            <span class="vo-qa-val">{{ (vo.suggested_extra && vo.suggested_extra[q.key]) || '—' }}</span>
                        </div>
                    </div>

                    <!-- Portal questions the approver answers -->
                    <div class="mt-2" v-if="(vo.questions || []).length">
                        <div class="vo-q-head mal-text">അപ്രൂവൽ ചോദ്യങ്ങൾ</div>
                        <template v-for="q in vo.questions" :key="q.key">
                            <label class="field-label mal-text">{{ q.label }} <span v-if="q.required" class="text-danger">*</span></label>
                            <template v-if="status === 'pending'">
                                <div v-if="q.type === 'yes_no'" class="vo-yn mb-2">
                                    <button type="button" class="vo-yn-opt"
                                        :class="{ 'vo-yn-opt--yes': (answers[vo.id] && answers[vo.id][q.key]) === 'Yes' }"
                                        @click="toggleYn(vo.id, q.key, 'Yes')">Yes</button>
                                    <button type="button" class="vo-yn-opt"
                                        :class="{ 'vo-yn-opt--no': (answers[vo.id] && answers[vo.id][q.key]) === 'No' }"
                                        @click="toggleYn(vo.id, q.key, 'No')">No</button>
                                </div>
                                <textarea v-else-if="q.type === 'textarea'" v-model="answers[vo.id][q.key]" class="vo-answer-input mb-2" rows="2"></textarea>
                                <select v-else-if="q.type === 'options'" v-model="answers[vo.id][q.key]" class="vo-answer-input mb-2">
                                    <option value="">Select</option>
                                    <option v-for="opt in (q.options || [])" :key="opt" :value="opt">{{ opt }}</option>
                                </select>
                                <input v-else v-model="answers[vo.id][q.key]" type="text" class="vo-answer-input mb-2" />
                            </template>
                            <div v-else class="vo-ans mal-text">{{ (vo.approval_answers && vo.approval_answers[q.key]) || '—' }}</div>
                        </template>
                    </div>

                    <p v-if="status === 'pending' && !allRequiredAnswered(vo)" class="mb-1 mt-2 mal-text"
                        style="font-size:11px;color:#d9534f;">
                        ചോദ്യങ്ങൾ പൂരിപ്പിച്ചതിനു ശേഷം അപ്രൂവ് ചെയ്യാം.
                    </p>
                    <div v-if="status === 'pending'" class="d-flex gap-2 mt-1">
                        <button type="button" class="btn btn-outline-danger btn-sm" style="flex:1;border-radius:8px;"
                            :disabled="approvingId === vo.id" @click="act(vo, 'reject')">
                            <ion-icon name="close-circle-outline" class="me-1"></ion-icon>
                            Reject
                        </button>
                        <button type="button" class="btn btn-success btn-sm" style="flex:1;border-radius:8px;"
                            :disabled="approvingId === vo.id || !allRequiredAnswered(vo)" @click="act(vo, 'approve')">
                            <span v-if="approvingId === vo.id" class="spinner-border spinner-border-sm me-1"></span>
                            <ion-icon v-else name="checkmark-circle-outline" class="me-1"></ion-icon>
                            Approve
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    </div>
</template>

<script>
import UserService from "@/services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

export default {
    name: "SnehaSparshamVoApprove",
    components: { AlertModel },
    data() {
        return {
            loading: true,
            status: "pending",
            list: [],
            answers: {},
            approvingId: null,
            alert_type: "",
            alert_message: "",
        };
    },
    mounted() {
        if (!this.$store.state.auth.user) {
            location.replace("/");
            return;
        }
        this.$root.updateParent("VO Approval");
        this.load();
    },
    methods: {
        setStatus(s) {
            this.status = s;
            this.load();
        },
        toggleYn(voId, key, value) {
            if (!this.answers[voId]) this.answers[voId] = {};
            // clicking the selected option unselects it
            this.answers[voId][key] = this.answers[voId][key] === value ? "" : value;
        },
        allRequiredAnswered(vo) {
            const ans = this.answers[vo.id] || {};
            return (vo.questions || []).every((q) =>
                !q.required || (ans[q.key] || "").toString().trim() !== ""
            );
        },
        load() {
            this.loading = true;
            UserService.authPostRequest("get-sneha-sparsham-pending-vos", { status: this.status }).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status === "success") {
                        this.list = response.data.data.list || [];
                        const ans = {};
                        this.list.forEach((vo) => {
                            ans[vo.id] = Object.assign({}, vo.approval_answers || {});
                        });
                        this.answers = ans;
                    } else {
                        this.list = [];
                    }
                },
                () => { this.loading = false; }
            );
        },
        statusLabel(s) {
            return s === 'approved' ? 'Approved' : s === 'rejected' ? 'Rejected' : 'Pending';
        },
        statusBadge(s) {
            return s === 'approved' ? 'bg-success' : s === 'rejected' ? 'bg-danger' : 'bg-warning text-dark';
        },
        act(vo, action) {
            if (action === 'approve') {
                for (const q of (vo.questions || [])) {
                    if (q.required && !((this.answers[vo.id] || {})[q.key] || "").toString().trim()) {
                        this.alert_type = "Warning";
                        this.alert_message = q.label + " is required.";
                        this.$refs.alert_model.openModel();
                        return;
                    }
                }
            }
            this.approvingId = vo.id;
            UserService.authPostRequest("approve-sneha-sparsham-vo", {
                id: vo.id,
                action: action,
                answers: this.answers[vo.id] || {},
            }).then(
                (response) => {
                    this.approvingId = null;
                    this.alert_type = response.data.status === "success" ? "Success" : "Warning";
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    if (response.data.status === "success") this.load();
                },
                () => { this.approvingId = null; }
            );
        },
    },
};
</script>

<style scoped>
.vo-tab {
    flex: 1;
    padding: 8px 0;
    border: none;
    border-radius: 8px;
    font-size: 12.5px;
    font-weight: 700;
    cursor: pointer;
}
.field-label { font-size: 11px; font-weight: 600; color: #64748b; margin-bottom: 3px; display: block; }
/* Explicit styling (not reliant on Bootstrap form-control/form-select being loaded) so answer
   fields for the portal-defined questions are clearly recognizable as inputs. */
.vo-answer-input {
    display: block;
    width: 100%;
    border: 1.5px solid #cbd5e1;
    border-radius: 10px;
    padding: 8px 10px;
    font-size: 14px;
    color: #1e293b;
    background: #fff;
}
.vo-answer-input:focus { outline: none; border-color: #1a418c; }
.vo-q-head { font-size: 12px; font-weight: 800; color: #1a418c; margin: 4px 0 8px; padding-top: 8px; border-top: 1px solid #f1f3f7; }
.vo-ans { font-size: 13px; font-weight: 600; color: #1e293b; margin-bottom: 8px; }
.vo-qa-row { display: flex; justify-content: space-between; gap: 10px; padding: 6px 0; border-top: 1px solid #f4f5f7; font-size: 12.5px; }
.vo-qa-label { color: #8a94a6; flex: 0 0 50%; }
.vo-qa-val { color: #1e293b; font-weight: 600; text-align: right; flex: 1; word-break: break-word; }
.vo-yn { display: flex; gap: 8px; }
.vo-yn-opt {
    flex: 1;
    padding: 8px 0;
    border: 1px solid #dbe1ea;
    border-radius: 8px;
    background: #fff;
    color: #64748b;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
}
.vo-yn-opt--yes { background: #eafaf1; border-color: #12a85a; color: #12a85a; }
.vo-yn-opt--no { background: #fff5f5; border-color: #d9534f; color: #d9534f; }
</style>
